import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { setClassNameInDefns } from '../../common/definitionHelper';
import { getUniqueKey } from '../../common/arrayHelper';
import ThreadSummaryBlockInternal from './ThreadSummaryBlockInternal';
import Simplebar from 'simplebar-react';

import _map from 'lodash/map';

const styles = theme => ({
    root: {
        height: 'calc(100% - 60px)',
    },
});

const getDefns = params => {
    const { props } = params;
    const { classes } = props;

    const defns = {};

    setClassNameInDefns(defns, classes);

    return defns;
};

const ThreadSummaries = props => {
    const { data, threadSummaryOnClick } = props;
    const { setShowMessageDetails } = props;

    const defns = getDefns({ props });
    return (
        <Simplebar {...defns.root}>
            {_map(data, (threadSummary, idx) => (
                <div key={`conversations${getUniqueKey()}`} onClick={() => setShowMessageDetails(true)}>
                    <ThreadSummaryBlockInternal data={threadSummary} onClick={threadSummaryOnClick} />
                </div>
            ))}
        </Simplebar>
    );
};

export default withStyles(styles)(ThreadSummaries);
